import { queryOptions } from '@tanstack/react-query';
import { mapResponseError } from '@mybusinessmate/api-client';
import type { Workbench } from '@mybusinessmate/schema';
import { api } from './api';
import { tasksKey } from './tasks-api';

/** Under the tasks key, so anything that moves a task (a slider, a version, a review) refreshes the board with it. */
export const workbenchQuery = queryOptions({
  queryKey: [...tasksKey, 'workbench'] as const,
  queryFn: async (): Promise<Workbench> => {
    const res = await api.api.workbench.$get();
    if (!res.ok) throw await mapResponseError(res);
    return (await res.json()) as Workbench;
  },
});
